// src/constants.js
export const ItemType = {
    REPORT: 'report',
  };
  